import { useAthleteContext } from '../context/AthleteContext';
import { readCloudReturnAthlete, clearCloudReturn } from '../utils/cloudIntegrationRedirect';
import type { CloudIntegrationProvider } from '../services/athleteSettingsApi';
import { hasPendingRegistrationConnections } from '../utils/pendingRegistrationConnections';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NmButton } from '../components/NmButton';

/** Same-context return from the API's provider/status/message redirect. */
export function CloudIntegrationCallbackPage({ provider, success, message }: {
  provider: CloudIntegrationProvider; success: boolean; message: string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isCoach, athletes, selectAthlete } = useAthleteContext();
  const [returnAthleteId] = useState(() => readCloudReturnAthlete(provider));
  const returnPath = hasPendingRegistrationConnections() ? '/register' : '/settings/connections';
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (isCoach && returnAthleteId != null && athletes.some(athlete => athlete.id === returnAthleteId)) {
      selectAthlete(returnAthleteId);
    }
    if (success) {
      clearCloudReturn();
      navigate(returnPath, { replace: true });
      return;
    }
    setDone(true);
  }, [success, message, navigate, returnPath, isCoach, athletes, selectAthlete, returnAthleteId]);

  if (!done) {
    return (
      <div className="flex-center" style={{ minHeight: '100dvh', background: 'var(--surface-0)' }}>
        <p style={{ color: 'var(--fg-3)' }}>{t('athleteSettings.connecting')}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'var(--surface-0)',
      }}
    >
      <div style={{ maxWidth: 400, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, marginBottom: 12 }}>
          {t(`athleteSettings.connections.apps.${provider}`)}: {success ? t('athleteSettings.connections.connected') : t('common.error', 'Connection failed')}
        </h1>
        {!success && message && (
          <p style={{ color: 'var(--fg-3)', marginBottom: 16, fontSize: 14 }}>{message}</p>
        )}
        <NmButton variant="primary" onClick={() => {
          clearCloudReturn();
          navigate(returnPath, { replace: true });
        }}>
          {t('common.back')}
        </NmButton>
      </div>
    </div>
  );
}
